import { parseTaskLocation } from "../taskRoutes";

function readQuery(search = "") {
  const params = new URLSearchParams(String(search || "").replace(/^\?/, "") ? search : "");
  return {
    filter: params.get("filter") || "needs-me",
    type: params.get("type") || "all",
    repositoryId: params.get("repository") || "",
    lens: params.get("lens") || "",
    guideId: params.get("guide") || "",
    category: params.get("category") || "",
    priority: params.get("priority") || "",
    status: params.get("status") || "",
    scope: params.get("scope") || "",
    q: params.get("q") || "",
  };
}

export function parseProductLocation(pathname = "", search = "") {
  const raw = String(pathname || "");
  const splitAt = raw.indexOf("?");
  const path = ((splitAt >= 0 ? raw.slice(0, splitAt) : raw).replace(/\/$/, "") || "/")
    .replace(/^\/(?:brain|company-brain)(?=\/|$)/, "/guides");
  const query = readQuery(search || (splitAt >= 0 ? raw.slice(splitAt) : ""));
  if (path === "/" || path === "/workspace" || path === "/dashboard") return { kind: "workspace", ...query };
  if (path === "/activity") return { kind: "activity", ...query };
  if (path === "/reviews") {
    const allowed = new Set(["running", "all", "attention", "failed", "historical", "completed"]);
    return { kind: "reviews", ...query, filter: allowed.has(query.filter) ? query.filter : "current" };
  }
  if (path === "/reviews/new" || path === "/tasks/review" || path === "/review") return { kind: "start", ...query };
  const detail = path.match(/^\/reviews\/([^/]+)$/);
  if (detail && detail[1] !== "new") return { ...query, kind: "decision", reviewId: decodeURIComponent(detail[1]) };
  if (path === "/guides/new") return { ...query, kind: "guide", guideId: "new" };
  if (path === "/guides/suggestions") return { ...query, kind: "guide-suggestions" };
  const suggestion = path.match(/^\/guides\/suggestions\/([^/]+)$/);
  if (suggestion) return { ...query, kind: "guide-suggestion", suggestionId: decodeURIComponent(suggestion[1]) };
  if (path === "/guides/conflicts") return { ...query, kind: "guide-conflicts" };
  const conflict = path.match(/^\/guides\/conflicts\/([^/]+)$/);
  if (conflict) return { ...query, kind: "guide-conflict", conflictId: decodeURIComponent(conflict[1]) };
  const history = path.match(/^\/guides\/([^/]+)\/history$/);
  if (history) return { ...query, kind: "guide-history", guideId: decodeURIComponent(history[1]) };
  const guide = path.match(/^\/guides\/([^/]+)$/);
  if (guide) return { ...query, kind: "guide", guideId: decodeURIComponent(guide[1]) };
  if (path === "/guides") return { kind: "guides", ...query };
  if (path === "/tasks/new") return { kind: "task-new", ...query };
  const taskSection = path.match(/^\/tasks\/([^/]+)\/(context|plan|build|verify)$/);
  if (taskSection) {
    return { ...query, kind: "task", taskId: decodeURIComponent(taskSection[1]), section: taskSection[2] };
  }
  const task = path.match(/^\/tasks\/([^/]+)$/);
  if (task && task[1] !== "new" && task[1] !== "review") {
    return { ...query, kind: "task", taskId: decodeURIComponent(task[1]), section: "overview" };
  }
  if (path === "/tasks" || path === "/build") return { kind: "tasks", ...query };
  if (path === "/settings") return { kind: "settings", ...query };
  if (path === "/tools/new") return { kind: "new-repo", ...query };
  if (path === "/tools") return { kind: "tools", ...query };
  if (path === "/about") return { kind: "about", ...query };
  if (path === "/admin") return { kind: "admin", ...query };
  const repository = parseTaskLocation(pathname, search);
  if (repository.repositoryId) {
    return { kind: "repository", ...repository, filter: query.filter, type: query.type };
  }
  return { kind: "reviews", ...query, filter: "current" };
}

export function reviewsPath({ filter, type, repositoryId } = {}) {
  const params = new URLSearchParams();
  if (filter && filter !== "current" && filter !== "needs-attention") params.set("filter", filter);
  if (type && type !== "all") params.set("type", type);
  if (repositoryId) params.set("repository", repositoryId);
  const query = params.toString();
  return query ? `/reviews?${query}` : "/reviews";
}

export function tasksPath({ filter, repositoryId } = {}) {
  const params = new URLSearchParams();
  if (filter && filter !== "needs-me") params.set("filter", filter);
  if (repositoryId) params.set("repository", repositoryId);
  const query = params.toString();
  return query ? `/tasks?${query}` : "/tasks";
}
